<template>
    <div class="p-grid">
         <div class="p-col-12">
             <div class="card p-shadow-1">
                 <h5>Sobre o Sistema</h5>
                 <hr>
                 <h5>Versão da Inteface</h5>
                 <label>{{ versaoInterface }}</label>
                 <h5>Versão do Sistema</h5>
                 <label>{{ versaoSistema }}</label>
             </div>
         </div>
     </div>
 </template>
 
 <script>
 import { CHAVE_USUARIO } from '@/global';
 
 export default {   
    data() {
        return {
            versaoSistema: '',
            versaoInterface: ''
        }
    },      
    mounted() {		
        let dadosUsuario = JSON.parse(sessionStorage.getItem(CHAVE_USUARIO)); 
        this.versaoSistema = dadosUsuario.versao;
        this.versaoInterface = process.env.VUE_APP_VERSAO;
    }
 }
 </script>
 
 <style>
 
 </style>